import { type AppIds, Apps, appWebDomains } from "@memorang/constants/apps";
import { isWeb } from "@memorang/helpers/platform";
import * as Application from "expo-application";
import Constants from "expo-constants";
const isDev = process.env.NODE_ENV === "development";

const domainToApp = new Map(
	Object.entries(appWebDomains).map(([app, domain]) => [domain, app as Apps]),
);

const appIdToApp: Record<AppIds, Apps> = {
	"com.memorang.therapyed": Apps.TherapyEd,
	"com.memorang.psi.insurance": Apps.Psi,
	"com.memorang.psi.insurance.testprep": Apps.Psi,
	"org.ets.toeflpracticeaicoach": Apps.toefl,
	"com.memorang.psi.wpi": Apps.wpi,
	"com.memorang.jbjs": Apps.Jbjs,
	"com.memorang.jbjs.app": Apps.Jbjs,
	"com.memorang.jbjs.image.challenge": Apps.Jbjs,
	"com.memorang.psi.aviation": Apps.faa,
	"com.memorang.cambridge.cupa.ema": Apps.cambridge,
	"com.memorang.aavsb": Apps.aavsb,
	"com.memorang.nascla": Apps.nascla,
	"com.memorang.psi.wocncb.testprep": Apps.wocncb,
	"com.memorang.psi.wocncb": Apps.wocncb,
	"com.memorang.psi.cmaa": Apps.cmaa,
	"com.memorang.aapa": Apps.aapa,
	"com.memorang.act.testprep": Apps.act,
	"com.memorang.acme.rockettestprep": Apps.rockettestprep,
	"org.ets.toeic-link-prep": Apps.toeic,
	"org.ets.toeic_link_prep": Apps.toeic,
	"com.memorang.pearson.pte": Apps.pte,
};

const resolveAppFromHost = (host: string): Apps | undefined => {
	const exact = domainToApp.get(host);

	if (exact) {
		return exact;
	}

	if (host.includes("partners-beta") || host.includes("partners")) {
		return Apps.TherapyEd;
	}

	return undefined;
};

const getTargetApp = (): Apps | undefined => {
	if (isDev) {
		return process.env.EXPO_PUBLIC_APP_NAME as Apps;
	}

	if (isWeb) {
		const host =
			typeof window !== "undefined"
				? window.location.hostname
				: (process.env.EXPO_PUBLIC_APP_NAME ?? "");
		return resolveAppFromHost(host);
	}

	const appId = Application.applicationId as AppIds;
	return appIdToApp[appId] ?? Apps.rockettestprep;
};
const nativeAppVersion =
	Application.nativeApplicationVersion ?? Constants.expoConfig?.version;
const buildNumber = Application.nativeBuildVersion ?? undefined;
const buildType = getTargetApp()!;

export { buildNumber, buildType, nativeAppVersion, resolveAppFromHost };
